import { sessionCache } from '@services/cache';
import { getNestedObject } from '@utils/object';

import { MODULE_NAME } from '../constants';

const getPropFromSession = (...props) => {
  const value = sessionCache.get(MODULE_NAME);

  if (value && props.length > 0) return getNestedObject(value, props);
  return value;
};

export default getPropFromSession;
